"use client";
import React from "react";
import { useNavigate } from "react-router-dom";
import "./SubHeroSlider.css";

function SubHeroSlider() {
    const navigate = useNavigate();

    const handlePackageClick = () => {
        navigate('/home-tour');
    };

    // Render only the booking form, adjusted for full screen width
    return (
        <div className="hero3-wrapper">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-12">
                        <div className="hero-booking style2">
                            <form action="mail.php" method="POST" className="booking-form style2 ajax-contact">
                                <div className="input-wrap">
                                    <div className="row align-items-center justify-content-between">
                                        <div className="form-group col-md-6 col-xl-auto">
                                            <div className="icon">
                                                <i className="fa-light fa-route"></i>
                                            </div>
                                            <div className="search-input">
                                                <label>Destination</label>
                                                <div className="nice-select-wrapper">
                                                    <div className="nice-select">
                                                        <span className="current">Select Destination</span>
                                                        <ul className="list">
                                                            <li className="option">Australia</li>
                                                            <li className="option">Dubai</li>
                                                            <li className="option">England</li>
                                                            <li className="option">Sweden</li>
                                                            <li className="option">Thailand</li>
                                                            <li className="option">Switzerland</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group col-md-6 col-xl-auto">
                                            <div className="icon">
                                                <i className="fa-regular fa-person-hiking"></i>
                                            </div>
                                            <div className="search-input">
                                                <label>Type</label>
                                                <div className="nice-select-wrapper">
                                                    <div className="nice-select">
                                                        <span className="current">Adventure</span>
                                                        <ul className="list">
                                                            <li className="option">Beach</li>
                                                            <li className="option">Group Tour</li>
                                                            <li className="option">Couple Tour</li>
                                                            <li className="option">Family Tour</li>
                                                            <li className="option" onClick={handlePackageClick} style={{cursor: 'pointer'}}>Package</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group col-md-6 col-xl-auto">
                                            <div className="icon">
                                                <i className="fa-light fa-clock"></i>
                                            </div>
                                            <div className="search-input">
                                                <label>Duration</label>
                                                <div className="nice-select-wrapper">
                                                    <div className="nice-select">
                                                        <span className="current">Duration</span>
                                                        <ul className="list">
                                                            <li className="option">1 days</li>
                                                            <li className="option">2 days</li>
                                                            <li className="option">3 days</li>
                                                            <li className="option">4 days</li>
                                                            <li className="option">5 days</li>
                                                            <li className="option">6 days</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-btn col-md-6 col-xl-auto">
                                            <button className="th-btn" type="submit">
                                                <img src="/assets/img/icon/search.svg" alt="" />
                                                Search
                                            </button>
                                        </div>
                                    </div>
                                    <p className="form-messages mb-0 mt-3"></p>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SubHeroSlider;
